import { useState } from 'react'

import { humanizeFieldName } from '@utils/string-utils'

import {
  QuickActionType,
  QuickActionTypeLabelMap
} from '@components/control-panel/calendar-filter-popover/types'
import Button from '@components/core/button'
import { Popover, PopoverContent, PopoverTrigger } from '@components/core/popover'
import { Separator } from '@components/core/separator'
import { Text } from '@components/core/text'
import { Select } from '@components/form/select'

import { useDispatch, useSelector } from '@store/index'
import {
  selectColumns,
  selectInitialFilterModelConfig,
  updateInitialFilterModelConfig
} from '@store/slices/component/table-config'

function DefaultFilterSettings({ onClose }: { onClose: () => void }) {
  const dispatch = useDispatch()
  const allColumns = useSelector(selectColumns)
  const initialFilterModelConfig = useSelector(selectInitialFilterModelConfig)
  const columns = _.filter(allColumns, (column) => column.cellDataType === 'dateString')
  const [selectedField, setSelectedField] = useState<string>(_.first(columns)?.field || '')
  const selectedColumn = _.find(columns, { field: selectedField })
  const selectedQuickAction = _.get(initialFilterModelConfig, [selectedField, 'quickAction'], '-')

  const setSelectedQuickAction = (value: string) => {
    let newModel = _.cloneDeep(initialFilterModelConfig || {})
    newModel = _.omit(newModel, [selectedField])
    if (value !== '-') {
      _.set(newModel, [selectedField], { quickAction: value })
    }
    dispatch(updateInitialFilterModelConfig(newModel))
  }

  return (
    <div>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <Text variant='details'>Field</Text>

          <Select
            className='w-36'
            value={selectedField}
            onChange={(value) => setSelectedField(value)}
            options={_.map(columns, ({ field }) => ({
              value: field,
              label: humanizeFieldName(field)
            }))}
          />
        </div>
        <div className='flex items-center gap-1'>
          <Button variant='outline' onClick={() => onClose()}>
            Close
          </Button>
        </div>
      </div>
      <Separator className='my-2' />
      {selectedColumn?.cellDataType === 'dateString' && (
        <div>
          <div className='flex items-center gap-2'>
            <Text variant='details'>Default Quick Action</Text>
            <Select
              className='w-36'
              value={selectedQuickAction}
              onChange={(value) => setSelectedQuickAction(value)}
              options={_.concat(
                [{ value: '-', label: 'None' }],
                _.map(QuickActionType, (quickAction) => ({
                  value: quickAction,
                  label: QuickActionTypeLabelMap[quickAction]
                }))
              )}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export function DefaultFilterModel({ showSettings = false }: { showSettings?: boolean }) {
  const [open, setOpen] = useState(false)

  const onOpenChange = (value: boolean) => setOpen(value)

  if (!showSettings) {
    return null
  }

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant='outline'>Default Filter Model</Button>
      </PopoverTrigger>
      <PopoverContent
        align='start'
        className='w-96 p-4'
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        {open && <DefaultFilterSettings onClose={() => setOpen(false)} />}
      </PopoverContent>
    </Popover>
  )
}
